import {Injectable} from '@angular/core';
import {RemoteHttpService} from '../../remote-http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ServerInfo} from '../../data/server-info';
import {ContentType, RemoteRequest} from '../../remote-request';
import * as global from '../../globals';
import { Custom_RequestMethod } from '../common-service';
/**
 * Created by ashok on 17/10/16.
 */

@Injectable()
export class ServerInfoService
{

    constructor(private http: RemoteHttpService,private method :Custom_RequestMethod
        ) {
    }

    /**
     * Get the server information
     * @returns {Observable<R>}
     */
    public serverInfo(packageName?: string): Observable<ServerInfo> {
        let data: any = {};
        let headers: any = {};
        if(packageName) data.packageName = packageName;
        let request = new RemoteRequest(global.ServerUrls.serverInfo, this.method.get,
            ContentType.URL_ENCODED_FORM_DATA, data, headers);

            // alert(typeof(request))

        return this.http.execute(request)
                   .pipe(map((resp: any) => {
                       let serverInfo: ServerInfo = resp;
                       if(serverInfo.showAds && serverInfo.adUrls){
                           let adUrls = [];
                           serverInfo.adUrls.forEach(url=>{
                               let absUrl = global.MygolfServer + "/" + url;
                               adUrls.push(absUrl);
                           });
                           serverInfo.adUrls = adUrls;
                       }
                       
                       return serverInfo;
                   }));
    }
}
